import { Text } from '@/shared/ui';
import { SuggestedQuestionCard } from './SuggestedQuestionCard';

export type SuggestedQuestionItem = {
  id: string;
  prompt: string;
  tagLabel?: string;
};

type Props = {
  title: string;
  questions: SuggestedQuestionItem[];
  onSelect: (prompt: string) => void;
  /** 表示列数。汎用チャットは 2、サイドパネルの事業内チャットは 1 */
  columns?: 1 | 2;
};

/** おすすめの質問をグリッド表示する。汎用チャット / 事業内チャットの両方から共用 */
export const SuggestedQuestionGrid = ({ title, questions, onSelect, columns = 2 }: Props) => (
  <div className="flex w-full max-w-[640px] flex-col gap-2">
    <Text variant="label">{title}</Text>
    <div className={columns === 1 ? 'flex flex-col gap-2' : 'grid grid-cols-2 gap-2'}>
      {questions.map((question) => (
        <SuggestedQuestionCard
          key={question.id}
          prompt={question.prompt}
          tagLabel={question.tagLabel}
          onClick={() => onSelect(question.prompt)}
        />
      ))}
    </div>
  </div>
);
